<template>
  <div class="vacancies-component">
    <div class="area">
      <div class="row vacancies-container" v-animated-show="utils.handleScroll">
        <h1 v-html="title" class="component-title col-12 centered"></h1>
        <div class="art col-3 col-md-12">
          <img :src="img.src" :alt="img.alt" />
        </div>
        <section class="list-section-banner" v-for="(l, i) in list" :key="i">
          <div class="content">
            <a class="description-link" :href="l.href">
              <Description
                class="mini icon-top icon-top-small"
                :isMoreTop="true"
                ref="bannerDescription"
                :title="l.title"
                :desc="l.desc"
                :more="l.date"
                :button="l.button"
                :href="l.href"
                :icon="l.icon"
                v-if="l.title"
              />
            </a>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../utils";
export default {
  name: "Vacancies",
  props: {
    img: Object,
    title: String,
    list: Array,
  },
  data() {
    return { utils: utils };
  },
};
</script>

<style lang="scss">
.vacancies-component {
  @media all and (max-width: $md) {
    padding-bottom: 79px;
  }
  @extend %page-block;
  padding-top: 0;
  padding-bottom: 140px;
  .vacancies-container {
    @media all and (max-width: $md) {
      grid-row-gap: 36px;
    }
  }
  .row-offset {
    @media all and (max-width: $md) {
      grid-gap: 26px;
    }
  }
  h1 {
    @media all and (max-width: $md) {
      margin-bottom: 0;
      margin-top: 0;
    }
    margin-bottom: 100px;
  }
  .list-section-banner {
    .description {
      .title {
        @media all and (max-width: $md) {
          height: unset;
        }
        // height: 3.6em;
      }
    }
    @media all and (max-width: $md) {
      text-align: center;
    }
    .button-description-container {
      @media all and (max-width: $md) {
        justify-self: center;
      }
    }
    &:nth-child(2n - 1) {
      @media all and (max-width: $md) {
        margin-left: 0;
        margin-right: 0;
        grid-column: 1 / span 12;
      }
      grid-column: 5 / span 4;
      margin-right: 26px;
      margin-left: 36px;
    }
    &:nth-child(2n) {
      @media all and (max-width: $md) {
        margin-right: 0;
        margin-left: 0;
        grid-column: 1 / span 12;
      }
      grid-column: 9 / span 3;
      margin-right: -26px;
    }
  }
  .art {
    @media all and (max-width: $md) {
      grid-column: 1 / span 12;
      mask-size: contain;
      background-size: cover;
      height: 100vw;
      width: 169px;
      align-self: center;
      justify-self: center;
      margin-left: 0;
      margin-right: -0;
      grid-row: 1;
      margin-top: 0;
      max-height: 107px;
      margin-top: 69px;
    }
    margin-top: -26px;
    grid-column: 1 / span 3;
    margin-left: 36px;
    margin-right: -16px;
  }
}
</style>
